exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".twoCol-6a61aa2f{display:flex;width:100%}.twoCol-6a61aa2f>div{flex:1 1 50%}.twoCol-6a61aa2f>div:first-child{padding-right:8px}.twoCol-6a61aa2f>div:last-child{padding-left:8px}.FlagButton-e2f3fc63 img{display:block;float:right;margin-top:10px}\n", ""]);

// Exports
exports.locals = {
	"twoCol": "twoCol-6a61aa2f",
	"FlagButton": "FlagButton-e2f3fc63"
};